

const affinities = {
  "affinity.title_description": "Allocate your contribution to a single sport or all.",
  "affinity.button": "Go to my account",
  "affinity.item.all-sports": "All sports",
}

export default affinities;
